"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const WishlistButtonView_1 = require("./views/WishlistButtonView");
const useAuth_1 = require("../lib/hooks/useAuth");
const useWishlist_1 = require("../lib/hooks/useWishlist");
function WishlistButton({ productId, className, }) {
    const { products, addToWishlist, removeFromWishlist, loading } = (0, useWishlist_1.useWishlist)();
    const signInPath = (0, app_1.useContextPath)('signIn');
    const { user } = (0, useAuth_1.useAuth)();
    const { push } = (0, app_1.useRouter)();
    const active = products.some(({ id }) => id === productId);
    const handleClick = (0, react_1.useCallback)((ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (loading) {
            return;
        }
        if (!user) {
            return void push(signInPath);
        }
        if (!active) {
            return void addToWishlist({ productId });
        }
        return void removeFromWishlist({ productId });
    }, [
        active,
        addToWishlist,
        loading,
        productId,
        push,
        removeFromWishlist,
        signInPath,
        user,
    ]);
    return ((0, jsx_runtime_1.jsx)(WishlistButtonView_1.WishlistButtonView, { className: className, active: active, onClick: handleClick }));
}
exports.WishlistButton = WishlistButton;
